import { apiService } from "api/apiService";
import type { FilterResource } from "api/generated";
import { myStudentsOverviewFromDto } from "meetings/student-meeting/api/mappers";
import type {
  MeetingMyStudentsOverview,
  MeetingMyStudentsOverviewDto,
} from "meetings/student-meeting/types";

export const fetchMyStudentsMeetings = async (
  teacherId: number,
  params: Record<string, string> = {},
): Promise<MeetingMyStudentsOverview> => {
  const { data } = await apiService.get<MeetingMyStudentsOverviewDto>(
    `api/teacher/${teacherId}/my-students/meetings`,
    { params },
  );
  return myStudentsOverviewFromDto(data);
};

export const fetchMyStudentsMeetingsFilters = async (
  teacherId: number,
): Promise<FilterResource[]> => {
  const {
    data: { data: filters },
  } = await apiService.get<{ data: FilterResource[] }>(
    `api/teacher/${teacherId}/my-students/meetings/filters`,
  );
  return filters;
};

export const shareMyStudentFeedback = async (
  meetingId: number,
  studentId: number,
): Promise<void> => {
  const formData = new FormData();
  formData.set("student_id", String(studentId));
  formData.set("meeting_id", String(meetingId));

  await apiService.post("api/share-feedback", formData);
};

export const saveMentorFeedback = async (params: {
  meetingId: number;
  studentId: number;
  teacherId: number;
  teacherShortage: string;
  summary: string;
}): Promise<void> => {
  const formData = new FormData();
  formData.set("summary", params.summary);
  formData.set("student_id", String(params.studentId));
  formData.set("meeting_id", String(params.meetingId));
  formData.set("teacher_id", String(params.teacherId));
  formData.set("teacher_shortage", params.teacherShortage);

  await apiService.post(
    `api/student/${params.studentId}/mentor-feedback?meeting_type=meeting`,
    formData,
  );
};
